import axios from 'axios';

import { getEnv } from '@/lib/env';

const publicClient = axios.create({
  baseURL: getEnv('VITE_API_URL'),
});

export interface PublicStockCar {
  id: string;
  title: string | null;
  manufacturer: string | null;
  model: string | null;
  derivative: string | null;
  trim: string | null;
  year: number | null;
  mileage: number | null;
  price: number | null;
  price_excludes_vat: boolean;
  fuel_type: string | null;
  body_type: string | null;
  transmission: string | null;
  drive_train: string | null;
  engine_size: string | null;
  bhp: number | null;
  doors: number | null;
  seats: number | null;
  colour: string | null;
  owners: number | null;
  condition: string | null;
  registration: string | null;
  images: string[];
  dealer: { name: string | null; town: string | null; postcode: string | null };
  details: Record<string, string | number | null>;
}

export const publicStockApi = {
  getCar: async (id: string): Promise<PublicStockCar> => {
    const response = await publicClient.get<PublicStockCar>(
      `/public/stock/${encodeURIComponent(id)}`,
    );
    return response.data;
  },
};
